import create from 'zustand';

const useOnboardingStore = create((set) => ({
  isOnboarding: false,
  setIsOnboarding: (isOnboarding) => set({ isOnboarding }),

}));

export default useOnboardingStore;
